"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _OrderHomePopup = _interopRequireDefault(require("./components/OrderHomePopup.vue"));
var _MenuPagePopup = _interopRequireDefault(require("./components/MenuPagePopup.vue"));
var _CommunityHomePopup = _interopRequireDefault(require("./components/CommunityHomePopup.vue"));
var _OrderHomePopupForm = _interopRequireDefault(require("./components/OrderHomePopupForm.vue"));
var _MenuPagePopupForm = _interopRequireDefault(require("./components/MenuPagePopupForm.vue"));
var _CommunityHomePopupForm = _interopRequireDefault(require("./components/CommunityHomePopupForm.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PopupConfiguration',
  components: {
    OrderHomePopup: _OrderHomePopup.default,
    MenuPagePopup: _MenuPagePopup.default,
    CommunityHomePopup: _CommunityHomePopup.default,
    OrderHomePopupForm: _OrderHomePopupForm.default,
    MenuPagePopupForm: _MenuPagePopupForm.default,
    CommunityHomePopupForm: _CommunityHomePopupForm.default
  },
  data: function data() {
    return {
      activeName: 'first',
      dynamicTabs: [],
      // 动态标签页数组
      tabIndex: 0,
      // 标签页索引计数器
      // 记录用户最后访问的固定标签页
      lastFixedTab: 'first'
    };
  },
  watch: {
    // 监听路由变化
    $route: function $route() {
      // 当路由变化时，关闭所有动态tab页
      this.closeAllDynamicTabs();
    },
    // 监听标签页切换
    activeName: function activeName(newVal) {
      // 检查是否切换到了固定标签页
      if (['first', 'second', 'third'].includes(newVal)) {
        // 记录用户最后访问的固定标签页
        this.lastFixedTab = newVal;

        // 如果当前有动态tab且不是从动态tab切换过来的，关闭所有动态tab
        if (this.dynamicTabs.length > 0 && !this.dynamicTabs.some(function (tab) {
          return tab.name === newVal;
        })) {
          this.closeAllDynamicTabs();
        }
      }
    }
  },
  methods: {
    // 关闭所有动态tab页
    closeAllDynamicTabs: function closeAllDynamicTabs() {
      // 保存需要关闭的tab名称
      var tabNamesToClose = this.dynamicTabs.map(function (tab) {
        return tab.name;
      });

      // 清空动态tabs数组
      this.dynamicTabs = [];

      // 如果当前激活的tab是动态tab，则切换到第一个固定tab
      if (!['first', 'second', 'third'].includes(this.activeName)) {
        this.activeName = 'first';
      }
    },
    // 处理添加弹窗事件
    handleAddPopup: function handleAddPopup(type, data) {
      this.createTab(type, null, false, data);
    },
    // 处理编辑弹窗事件
    handleEditPopup: function handleEditPopup(type, data) {
      // data 现在是 id
      this.createTab(type, null, true, data);
    },
    // 根据类型获取弹窗类型值
    getPopupType: function getPopupType(type) {
      var popupTypeMap = {
        'orderHome': 2,
        // 首页弹窗
        'menuPage': 1,
        // 菜单页弹窗
        'communityHome': 3 // 社区首页弹窗
      };
      return popupTypeMap[type] || 2;
    },
    // 创建标签页的通用方法
    createTab: function createTab(type, data, isEdit, editId) {
      if (!isEdit) {
        // 查找是否已存在同类型的"添加"tab
        var existTab = this.dynamicTabs.find(function (tab) {
          return tab.type === type && !tab.isEdit;
        });
        if (existTab) {
          this.activeName = existTab.name;
          return;
        }
      }
      if (isEdit) {
        var _existTab = this.dynamicTabs.find(function (tab) {
          return tab.type === type && tab.isEdit;
        });
        if (_existTab) {
          // 更新已有编辑 tab 的内容
          _existTab.data = data;
          _existTab.editId = editId;
          this.activeName = _existTab.name;
          return;
        }
      }
      // 根据类型创建新标签页
      var newTab = null;
      switch (type) {
        case 'orderHome':
          newTab = {
            title: isEdit ? '编辑点餐首页弹窗' : '添加点餐首页弹窗',
            name: "tab-".concat(++this.tabIndex),
            type: type,
            data: data,
            isEdit: isEdit,
            editId: editId || null
          };
          break;
        case 'menuPage':
          newTab = {
            title: isEdit ? '编辑菜单页弹窗' : '添加菜单页弹窗',
            name: "tab-".concat(++this.tabIndex),
            type: type,
            data: data,
            isEdit: isEdit,
            editId: editId || null
          };
          break;
        case 'communityHome':
          newTab = {
            title: isEdit ? '编辑社区首页弹窗' : '添加社区首页弹窗',
            name: "tab-".concat(++this.tabIndex),
            type: type,
            data: data,
            isEdit: isEdit,
            editId: editId || null
          };
          break;
        default:
          console.warn('未知的弹窗类型:', type);
          return;
      }
      if (newTab) {
        this.dynamicTabs.push(newTab);
        this.activeName = newTab.name;
      }
    },
    // 表单保存成功后刷新对应列表并关闭标签页
    handleFormSaved: function handleFormSaved(type, tabName) {
      if (type === 'orderHome' && this.$refs.orderList) {
        this.$refs.orderList.fetchList();
      } else if (type === 'menuPage' && this.$refs.menuList) {
        this.$refs.menuList.fetchList();
      } else if (type === 'communityHome' && this.$refs.communityList) {
        this.$refs.communityList.fetchList();
      }
      this.removeTab(tabName);
    },
    // 移除标签页
    removeTab: function removeTab(targetName) {
      var _this = this;
      var tabs = this.dynamicTabs;
      var activeName = this.activeName;
      if (activeName === targetName) {
        tabs.forEach(function (tab, index) {
          if (tab.name === targetName) {
            var nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            } else {
              // 如果没有动态标签页了，切换到用户最后访问的固定标签页
              activeName = _this.lastFixedTab;
            }
          }
        });
      }
      this.activeName = activeName;
      this.dynamicTabs = tabs.filter(function (tab) {
        return tab.name !== targetName;
      });
    },
    // 标签页点击事件处理
    handleClick: function handleClick(tab) {
      // 可以在这里添加标签页点击时的逻辑
      console.log('标签页被点击:', tab);
    },
    // 根据类型获取对应的表单组件
    getFormComponent: function getFormComponent(type) {
      var componentMap = {
        'orderHome': 'OrderHomePopupForm',
        'menuPage': 'MenuPagePopupForm',
        'communityHome': 'CommunityHomePopupForm'
      };
      return componentMap[type] || 'div';
    }
  },
  // 在组件销毁前关闭所有动态tab
  beforeDestroy: function beforeDestroy() {
    this.closeAllDynamicTabs();
  }
};